
import React, { useState, useEffect } from 'react';
import { getMPIVersion } from "../api/APIUtils";

export function AboutInfo({isAdmin, isOperator,isReadOnly, email, entity, group}) {
    const [data, setData] = useState(null);
    const [mpiVersion, setMPIVersion] = useState(null);
  
    useEffect(() => {
      async function fetchData() {
        try {
          const version = await getMPIVersion();
          setMPIVersion(version);
        } catch (error) {
          console.error('Error fetching MPI version:', error);
        }
      }
      fetchData();
    }, [mpiVersion]);
  
    return (
      <div>
        <div>
          Roles: {isAdmin ? "Admin" : ""} {isOperator ? "Operator" : ""} {isReadOnly ? "ReadOnly" : ""}
        </div>
        <div>
          Groups: {group ? decodeURIComponent(group) : 'undefined'}
        </div>
        <div>User: {email} </div>
        <div>Entity: {entity}</div>
        {/* <div>Version: 0.1.3</div> */}
        {/* Check if data is still loading */}
        {mpiVersion === null ? (
          <div>MPI Version (Amplify): Loading...</div>
        ) : (
          <div>MPI Version (Amplify): {mpiVersion}</div>
        )}
      </div>
    );
  }
  